import React, { useState, useEffect } from "react";
import "../../css/home/sas.css";

function SAS() {
    const modules = [
        {
            Header: "Yerli",
            image: "product.png",
            content: `Donanım ve Yazılımın tasarımı tamamen DAP Şarja aittir
Yerli üretim olup, Türkiye'de geliştirilmiştir.`,
        },
        {
            Header: "Güçlü",
            image: "full-battery.png",
            content: `AC istasyonlarımız aracınızın modeline göre alabileceği
maksimum şarj gücünü otomatik olarak belirler ve o güç ile çalışır.`,
        },
        {
            Header: "Ergonomik",
            image: "service.png",
            content: `İstasyonlarımız ile beraber temin edebileceğiniz standları
ile birlikte her mekan için uygun çözümler sunar.`,
        },
        {
            Header: "Hızlı",
            image: "vehicle.png",
            content: "İstasyonlarımız soketini aracınıza taktığınız an şarja başlar.",
        },
        {
            Header: "Hizmet",
            image: "gear.png",
            content: `150'den fazla çalışanımız ve 35 yıllık tecrübemiz ile
Türkiye'nin her yerinde satış sonrası da hizmetinizdeyiz.`,
        },
        {
            Header: "Teknolojik",
            image: "charging-station.png",
            content: `Herhangi bir sorun yaşadığınızda, uzaktan erişim ile
sorununuzu kolayca çözebiliriz.`,
        },
    ];
    
    // Ekran boyutunu izlemek için state
    const [screenWidth, setScreenWidth] = useState(
        typeof window !== 'undefined' ? window.innerWidth : 1200
    );
    
    useEffect(() => {
        // Ekran boyutunu izleme fonksiyonu
        const handleResize = () => {
            setScreenWidth(window.innerWidth);
        };
        
        // Event listener ekle
        window.addEventListener('resize', handleResize);
        
        // Temizleme fonksiyonu
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    
    // Ekran boyutuna göre modül yerleşimini belirle
    const getGridLayout = () => {
        if (screenWidth >= 1024) {
            // Masaüstü için düzgün bir grid yerleşimi
            return (
                <>
                    <div className="grid-row">
                        {modules.map((module, index) => (
                            <SASModule key={index} {...module} />
                        ))}
                    </div>
                </>
            );
        } else if (screenWidth >= 768) {
            // Tablet için düzgün bir grid yerleşimi
            return (
                <>
                    <div className="grid-row">
                        {modules.map((module, index) => (
                            <SASModule key={index} {...module} />
                        ))}
                    </div>
                </>
            );
        } else {
            // Mobil için düzgün bir grid yerleşimi
            return (
                <>
                    <div className="grid-row">
                        {modules.map((module, index) => (
                            <SASModule key={index} {...module} />
                        ))}
                    </div>
                </>
            );
        }
    };
    
    return <div className="SASO">{getGridLayout()}</div>;
}

const SASModule = ({ Header, image, content }) => {
    return (
        <div className="SAS">
            <h3>{Header}</h3>
            <img 
                src={`assets/home/SAS/${image}`} 
                alt={Header}
                loading="lazy"
            />
            <p>{content}</p>
        </div>
    );
};

export default SAS;